var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4166 4.99998C10.4166 5.2301 10.23 5.41665 9.99992 5.41665C9.7698 5.41665 9.58325 5.2301 9.58325 4.99998C9.58325 4.76986 9.7698 4.58331 9.99992 4.58331C10.23 4.58331 10.4166 4.76986 10.4166 4.99998Z",
    stroke: "#2D2D38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4166 9.99998C10.4166 10.2301 10.23 10.4166 9.99992 10.4166C9.7698 10.4166 9.58325 10.2301 9.58325 9.99998C9.58325 9.76986 9.7698 9.58331 9.99992 9.58331C10.23 9.58331 10.4166 9.76986 10.4166 9.99998Z",
    stroke: "#2D2D38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 4.99998C15.4166 5.2301 15.23 5.41665 14.9999 5.41665C14.7698 5.41665 14.5833 5.2301 14.5833 4.99998C14.5833 4.76986 14.7698 4.58331 14.9999 4.58331C15.23 4.58331 15.4166 4.76986 15.4166 4.99998Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 9.99998C15.4166 10.2301 15.23 10.4166 14.9999 10.4166C14.7698 10.4166 14.5833 10.2301 14.5833 9.99998C14.5833 9.76986 14.7698 9.58331 14.9999 9.58331C15.23 9.58331 15.4166 9.76986 15.4166 9.99998Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41658 4.99998C5.41658 5.2301 5.23004 5.41665 4.99992 5.41665C4.7698 5.41665 4.58325 5.2301 4.58325 4.99998C4.58325 4.76986 4.7698 4.58331 4.99992 4.58331C5.23004 4.58331 5.41658 4.76986 5.41658 4.99998Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41658 9.99998C5.41658 10.2301 5.23004 10.4166 4.99992 10.4166C4.7698 10.4166 4.58325 10.2301 4.58325 9.99998C4.58325 9.76986 4.7698 9.58331 4.99992 9.58331C5.23004 9.58331 5.41658 9.76986 5.41658 9.99998Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4166 15C10.4166 15.2301 10.23 15.4166 9.99992 15.4166C9.7698 15.4166 9.58325 15.2301 9.58325 15C9.58325 14.7699 9.7698 14.5833 9.99992 14.5833C10.23 14.5833 10.4166 14.7699 10.4166 15Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 15C15.4166 15.2301 15.23 15.4166 14.9999 15.4166C14.7698 15.4166 14.5833 15.2301 14.5833 15C14.5833 14.7699 14.7698 14.5833 14.9999 14.5833C15.23 14.5833 15.4166 14.7699 15.4166 15Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41658 15C5.41658 15.2301 5.23004 15.4166 4.99992 15.4166C4.7698 15.4166 4.58325 15.2301 4.58325 15C4.58325 14.7699 4.7698 14.5833 4.99992 14.5833C5.23004 14.5833 5.41658 14.7699 5.41658 15Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6437c4e7.svg";
export { ForwardRef as ReactComponent };